"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4249],{

/***/ 77557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_esm; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@pcln/analytics/dist/esm/browser.js + 22 modules
var browser = __webpack_require__(45741);
;// CONCATENATED MODULE: ./node_modules/@pcln/mobile-header/lib-esm/MobileTab.js
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var primaryBase = (0,utils/* getPaletteColor */.ow)('primary.base');
var borderLight = (0,utils/* getPaletteColor */.ow)('text.light');
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  height: 73px;\n  min-width: auto;\n  padding: 12px 10px 0px 10px;\n  position: relative;\n  text-decoration: none;\n  white-space: nowrap;\n  width: 200px;\n\n  &:first-child {\n    padding-left: 16px;\n  }\n  &:last-child {\n    padding-right: 16px;\n  }\n\n  @media only screen and (max-width: 320px) {\n    padding: 12px 6px 0px 6px;\n\n    &:first-child {\n      padding-left: 12px;\n    }\n    &:last-child {\n      padding-right: 12px;\n    }\n  }\n\n  // Note: div:nth-child(n+2) is the ActiveBottom Bar from mobile-header\n  div:nth-child(n + 2) {\n    left: 0;\n  }\n\n  &:active {\n    background: ", ";\n    color: ", ";\n    text-decoration: none;\n  }\n\n  &:focus,\n  &:visited,\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  background: ", ";\n  color: ", ";\n  height: 73px;\n  min-width: auto;\n  padding: 12px 10px 0px 10px;\n  position: relative;\n  text-decoration: none;\n  white-space: nowrap;\n  width: 200px;\n\n  &:first-child {\n    padding-left: 16px;\n  }\n  &:last-child {\n    padding-right: 16px;\n  }\n\n  @media only screen and (max-width: 320px) {\n    padding: 12px 6px 0px 6px;\n\n    &:first-child {\n      padding-left: 12px;\n    }\n    &:last-child {\n      padding-right: 12px;\n    }\n  }\n\n  // Note: div:nth-child(n+2) is the ActiveBottom Bar from mobile-header\n  div:nth-child(n + 2) {\n    left: 0;\n  }\n\n  &:active {\n    background: ", ";\n    color: ", ";\n    text-decoration: none;\n  }\n\n  &:focus,\n  &:visited,\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n  }\n"])), (0,utils/* getPaletteColor */.ow)('background.lightest'), function (props) { return (props.isActive ? primaryBase : borderLight); }, (0,utils/* getPaletteColor */.ow)('background.lightest'), function (props) { return (props.isActive ? primaryBase : borderLight); }, function (props) { return (props.isActive ? primaryBase : borderLight); });
var ActiveBottomBar = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  bottom: 0;\n  height: 4px;\n  position: absolute;\n  width: 100%;\n"], ["\n  background: ", ";\n  bottom: 0;\n  height: 4px;\n  position: absolute;\n  width: 100%;\n"])), primaryBase);
function MobileTab(_a) {
    var category = _a.category, item = _a.item, selectedItem = _a.selectedItem;
    var autobotElement = item.autobotElement, href = item.href, name = item.name, icon = item.icon, title = item.title, child = item.child;
    var isActivePage = name === selectedItem;
    var displayText = child || (react.createElement(Text/* default */.ZP, { fontSize: '11px', bold: true, caps: true }, title));
    function onClick() {
        browser/* default.logEvent */.Z.logEvent({
            action: 'Tab',
            label: title,
            category: category,
        });
    }
    return (react.createElement(StyledLink, { "data-autobot-element-id": autobotElement, href: isActivePage ? null : href, isActive: isActivePage, onClick: onClick },
        react.createElement(Flex/* default */.Z, { alignItems: 'center', flexDirection: 'column' },
            icon,
            react.createElement(Box/* default */.Z, { mt: 1, textAlign: 'center' }, displayText)),
        isActivePage && react.createElement(ActiveBottomBar, null)));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=MobileTab.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/mobile-header/lib-esm/MobileTabRefresh.js
var MobileTabRefresh_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var MobileTabRefresh_primaryBase = (0,utils/* getPaletteColor */.ow)('primary.base');
var regularBackground = (0,utils/* getPaletteColor */.ow)('priceSecondary.light');
var lightBackground = (0,utils/* getPaletteColor */.ow)('background.light');
var TabInnerElementWidth = '48px';
var TabContaineWidth = 200;
var MobileTabRefresh_StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z)(MobileTabRefresh_templateObject_1 || (MobileTabRefresh_templateObject_1 = MobileTabRefresh_makeTemplateObject(["\n  &:first-child {\n    padding-left: 16px;\n  }\n  &:last-child {\n    padding-right: 16px;\n  }\n\n  &:focus,\n  &:visited,\n  &:hover {\n    text-decoration: none;\n  }\n"], ["\n  &:first-child {\n    padding-left: 16px;\n  }\n  &:last-child {\n    padding-right: 16px;\n  }\n\n  &:focus,\n  &:visited,\n  &:hover {\n    text-decoration: none;\n  }\n"])));
var StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(MobileTabRefresh_templateObject_2 || (MobileTabRefresh_templateObject_2 = MobileTabRefresh_makeTemplateObject(["\n  border: 2px solid ", ";\n  background-color: ", ";\n\n  > div {\n    line-height: 0;\n  }\n"], ["\n  border: 2px solid ", ";\n  background-color: ", ";\n\n  > div {\n    line-height: 0;\n  }\n"])), function (props) { return (props.isActive ? MobileTabRefresh_primaryBase : 'none'); }, function (props) { return (props.isActive ? regularBackground : lightBackground); });
function MobileTabRefresh(_a) {
    var category = _a.category, item = _a.item, selectedItem = _a.selectedItem;
    var autobotElement = item.autobotElement, href = item.href, name = item.name, icon = item.icon, iconFill = item.iconFill, title = item.title, child = item.child;
    var isActivePage = name === selectedItem;
    var displayText = child || (react.createElement(Text/* default */.ZP, { width: TabInnerElementWidth, fontSize: '12px', bold: isActivePage }, title));
    function onClick() {
        browser/* default.logEvent */.Z.logEvent({
            action: 'Tab',
            label: title,
            category: category,
        });
    }
    return (react.createElement(MobileTabRefresh_StyledLink, { pt: 12, pb: 0, px: 10, width: TabContaineWidth, color: MobileTabRefresh_primaryBase, "data-autobot-element-id": autobotElement, href: isActivePage ? null : href, isActive: isActivePage, onClick: onClick },
        react.createElement(Flex/* default */.Z, { alignItems: 'center', flexDirection: 'column' },
            react.createElement(StyledFlex, { size: TabInnerElementWidth, justifyContent: 'center', alignItems: 'center', borderRadius: 'full', isActive: isActivePage }, isActivePage ? iconFill : icon),
            react.createElement(Box/* default */.Z, { mt: 1, textAlign: 'center' }, displayText))));
}
var MobileTabRefresh_templateObject_1, MobileTabRefresh_templateObject_2;
//# sourceMappingURL=MobileTabRefresh.js.map
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Bed.js
var Bed = __webpack_require__(46638);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Flights.js
var Flights = __webpack_require__(98611);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Luggage.js
var Luggage = __webpack_require__(26884);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Cars.js
var Cars = __webpack_require__(70895);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Cruises.js
var Cruises = __webpack_require__(3474);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/HotelsOutline.js
var HotelsOutline = __webpack_require__(31883);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/HotelsFill.js
var HotelsFill = __webpack_require__(28845);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/FlightsOutline.js
var FlightsOutline = __webpack_require__(31452);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/FlightsFill.js
var FlightsFill = __webpack_require__(75749);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/PackagesOutline.js
var PackagesOutline = __webpack_require__(77681);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/PackagesFill.js
var PackagesFill = __webpack_require__(83976);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/CarsOutline.js
var CarsOutline = __webpack_require__(26102);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/CarsFill.js
var CarsFill = __webpack_require__(40165);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/CriusesOutline.js
var CriusesOutline = __webpack_require__(76023);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/CriusesFill.js
var CriusesFill = __webpack_require__(31499);
;// CONCATENATED MODULE: ./node_modules/@pcln/mobile-header/lib-esm/constants/index.js



var ITEMS = [
    {
        autobotElement: 'DASH_MWEB_TAB_HOTELS',
        href: '/hotels',
        name: 'Hotels',
        icon: react.createElement(Bed/* default */.Z, null),
        title: 'HOTELS',
    },
    {
        autobotElement: 'DASH_MWEB_TAB_FLIGHTS',
        href: '/flights',
        name: 'Flights',
        icon: react.createElement(Flights/* default */.Z, null),
        title: 'FLIGHTS',
    },
    {
        autobotElement: 'DASH_MWEB_TAB_PACKAGES',
        href: '/vacationpackages',
        name: 'Packages',
        icon: react.createElement(Luggage/* default */.Z, null),
        title: 'HOTEL + FLIGHT',
    },
    {
        autobotElement: 'DASH_MWEB_TAB_CARS',
        href: '/rentalcars',
        name: 'Cars',
        icon: react.createElement(Cars/* default */.Z, null),
        title: 'CARS',
    },
    {
        autobotElement: 'DASH_MWEB_TAB_CRUISES',
        href: 'https://cruises.priceline.com/?utm_medium=partner_site_topnav&utm_source=pclnhp_top_nav&utm_campaign=globalnav&utm_content=hp_top_nav_cruise',
        name: 'Cruises',
        icon: react.createElement(Cruises/* default */.Z, null),
        title: 'CRUISES',
    },
];
var ITEMS_REFRESH = [
    {
        autobotElement: 'DASH_MWEB_TAB_HOTELS',
        href: '/hotels',
        name: 'Hotels',
        icon: react.createElement(HotelsOutline/* default */.Z, { size: '32px' }),
        iconFill: react.createElement(HotelsFill/* default */.Z, { size: '32px' }),
        title: 'Hotels',
    },
    {
        autobotElement: 'DASH_MWEB_TAB_FLIGHTS',
        href: '/flights',
        name: 'Flights',
        icon: react.createElement(FlightsOutline/* default */.Z, { size: '32px' }),
        iconFill: react.createElement(FlightsFill/* default */.Z, { size: '32px' }),
        title: 'Flights',
    },
    {
        autobotElement: 'DASH_MWEB_TAB_PACKAGES',
        href: '/vacationpackages',
        name: 'Packages',
        icon: react.createElement(PackagesOutline/* default */.Z, { size: '32px' }),
        iconFill: react.createElement(PackagesFill/* default */.Z, { size: '32px' }),
        title: 'Bundle & Save',
    },
    {
        autobotElement: 'DASH_MWEB_TAB_CARS',
        href: '/rentalcars',
        name: 'Cars',
        icon: react.createElement(CarsOutline/* default */.Z, { size: '32px' }),
        iconFill: react.createElement(CarsFill/* default */.Z, { size: '32px' }),
        title: 'Cars',
    },
    {
        autobotElement: 'DASH_MWEB_TAB_CRUISES',
        href: 'https://cruises.priceline.com/?utm_medium=partner_site_topnav&utm_source=pclnhp_top_nav&utm_campaign=globalnav&utm_content=hp_top_nav_cruise',
        name: 'Cruises',
        icon: react.createElement(CriusesOutline/* default */.Z, { size: '32px' }),
        iconFill: react.createElement(CriusesFill/* default */.Z, { size: '32px' }),
        title: 'Cruises',
    },
];

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/mobile-header/lib-esm/MobileHeader.js
var MobileHeader_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






var MobileTabsContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(MobileHeader_templateObject_1 || (MobileHeader_templateObject_1 = MobileHeader_makeTemplateObject(["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  overflow-x: scroll;\n  width: 100%;\n"], ["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  overflow-x: scroll;\n  width: 100%;\n"])), (0,utils/* getPaletteColor */.ow)('border.base'), (0,utils/* getPaletteColor */.ow)('border.base'));
var MobileTabsContainerRefresh = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(MobileHeader_templateObject_2 || (MobileHeader_templateObject_2 = MobileHeader_makeTemplateObject(["\n  scrollbar-width: none;\n  overflow-x: scroll;\n  width: 100%;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  scrollbar-width: none;\n  overflow-x: scroll;\n  width: 100%;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    /** @public */
])));
/** @public */
var MobileHeader = function (_a) {
    var analyticsCategory = _a.analyticsCategory, _b = _a.items, items = _b === void 0 ? ITEMS : _b, selectedItem = _a.selectedItem, mustRefreshIcons = _a.mustRefreshIcons;
    var tabs = items.map(function (item) { return (react.createElement(react.Fragment, null, mustRefreshIcons ? (react.createElement(MobileTabRefresh, { category: analyticsCategory, key: item.autobotElement, item: item, selectedItem: selectedItem })) : (react.createElement(MobileTab, { category: analyticsCategory, key: item.autobotElement, item: item, selectedItem: selectedItem })))); });
    return (react.createElement(Hide/* default */.Z, { md: true, lg: true, xl: true, xxl: true }, mustRefreshIcons ? (react.createElement(MobileTabsContainerRefresh, null, tabs)) : (react.createElement(MobileTabsContainer, null, tabs))));
};
MobileHeader.items = ITEMS;
MobileHeader.itemsRefresh = ITEMS_REFRESH;
/* harmony default export */ var lib_esm_MobileHeader = (MobileHeader);
var MobileHeader_templateObject_1, MobileHeader_templateObject_2;
//# sourceMappingURL=MobileHeader.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/mobile-header/lib-esm/index.js

/* harmony default export */ var lib_esm = (lib_esm_MobileHeader);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 34249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HomeMobile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(92591);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(92833);
/* harmony import */ var _components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29293);
/* harmony import */ var _components_HotelsTonight_HotelsTonight__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24003);
/* harmony import */ var _components_PromoFeatureBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61094);
/* harmony import */ var _components_Hotels_SearchForm_Form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68916);
/* harmony import */ var _components_SmsOptIn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25821);
/* harmony import */ var _components_ConditionalRender__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93314);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68464);
/* harmony import */ var _components_Hotels_SearchForm_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84822);
/* harmony import */ var _components_MobileHeaderWrapper_MobileHeaderWrapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8750);
/* harmony import */ var _hooks_useMostRecentFutureBooking__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81850);
/* harmony import */ var _components_CrossSell__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90020);
/* harmony import */ var _components_EmailSignUp__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86229);
/* harmony import */ var _constants_content__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(66410);
/* harmony import */ var _hooks_useSEMSearchHeadline__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(32881);
/* harmony import */ var _components_Promos_MarketingTout_MarketingTout__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(10441);
/* harmony import */ var _components_ExtendStay__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(38292);
/* harmony import */ var _hooks_useCityNameInFormHeadlineForSEM__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(40813);
/* harmony import */ var _hooks_useContentfulSearchFormHeadlines__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(98673);
/* harmony import */ var _hooks_useExtendStayBooking__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(83405);
/* harmony import */ var _context_SearchFormContext__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(51069);
/* harmony import */ var _SearchForm_Bumpers__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(75755);

























var PRIMARY_HEADING_FALLBACK = "Find your next hotel deal";
function HomeMobile() {
    var mostRecentFutureBooking = (0,_hooks_useMostRecentFutureBooking__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), _signInStatus = ref.signInStatus, signedIn = _signInStatus.signedIn, passiveSignIn = _signInStatus.passiveSignIn, firstName = ref.customer.firstName;
    var extendData = (0,_hooks_useExtendStayBooking__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)();
    var isSignedIn = signedIn || passiveSignIn;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), location = ref1[0], setLocation = ref1[1];
    var prePopHeadline = (0,_hooks_useCityNameInFormHeadlineForSEM__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(location);
    var SEMHeadline = (0,_hooks_useSEMSearchHeadline__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)();
    var form = (0,_hooks_useContentfulSearchFormHeadlines__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)("searchFormHotels");
    /**
   * TODO: Add these values to contentful
   */ var headlineVIP = firstName ? _constants_content__WEBPACK_IMPORTED_MODULE_14__/* ["default"].homepage.vip.headlineWithName.replace */ .ZP.homepage.vip.headlineWithName.replace("{firstName}", firstName) : _constants_content__WEBPACK_IMPORTED_MODULE_14__/* ["default"].homepage.vip.defaultHeading */ .ZP.homepage.vip.defaultHeading;
    var subheadline = isSignedIn ? _constants_content__WEBPACK_IMPORTED_MODULE_14__/* ["default"].homepage.hotel.signedInSubHeading */ .ZP.homepage.hotel.signedInSubHeading : (form === null || form === void 0 ? void 0 : form.mobileSubheadline) || "";
    var headline = isSignedIn ? headlineVIP : prePopHeadline || SEMHeadline || (form === null || form === void 0 ? void 0 : form.mobileHeadline) || PRIMARY_HEADING_FALLBACK;
    var CrossSellContent = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: mostRecentFutureBooking ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CrossSell__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                booking: mostRecentFutureBooking
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PromoFeatureBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MobileHeaderWrapper_MobileHeaderWrapper__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                selectedProductName: "Hotels",
                mb: 4,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_context_SearchFormContext__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                            px: 3,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            tag: "h1",
                                            color: "text.heading",
                                            textStyle: "heading3",
                                            text: headline
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            mt: 1,
                                            tag: "h2",
                                            color: "text.light",
                                            textStyle: "subheading6",
                                            text: subheadline
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    mt: 3,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Hotels_SearchForm_Form__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        onSubmit: _components_Hotels_SearchForm_utils__WEBPACK_IMPORTED_MODULE_9__/* .handleSubmitForHotels */ .Ky,
                                        setLocation: setLocation
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchForm_Bumpers__WEBPACK_IMPORTED_MODULE_22__/* .HotelsBumper */ .np, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                m: 3,
                children: extendData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ExtendStay__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, extendData)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CrossSellContent, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                m: 3,
                mt: "48px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConditionalRender__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        experimentCode: "HP_SMS_COMPONENT",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConditionalRender__WEBPACK_IMPORTED_MODULE_7__/* .Experiment */ .KS, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SmsOptIn__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Promos_MarketingTout_MarketingTout__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                m: 3,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HotelsTonight_HotelsTonight__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                        textAlign: "center",
                        mt: 4,
                        width: 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "div-gpt-ad-1544641976893-0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EmailSignUp__WEBPACK_IMPORTED_MODULE_13__/* .EmailSignUpToast */ .Zz, {
                sourceId: "LANDING_HOME_TOAST_MWEB",
                isMobile: true
            })
        ]
    });
}


/***/ }),

/***/ 24003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HotelsTonight; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./src/utils/date-helper.tsx
var date_helper = __webpack_require__(68511);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/hooks/useGeoPosition.ts
var useGeoPosition = __webpack_require__(29657);
;// CONCATENATED MODULE: ./src/components/HotelsTonight/SleepIcon.tsx


var SleepIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? "#687B8E" : _color, _translateX = param.translateX, translateX = _translateX === void 0 ? -2 : _translateX, _translateY = param.translateY, translateY = _translateY === void 0 ? -3 : _translateY, _viewBoxHeight = param.viewBoxHeight, viewBoxHeight = _viewBoxHeight === void 0 ? 32 : _viewBoxHeight, _viewBoxWidth = param.viewBoxWidth, viewBoxWidth = _viewBoxWidth === void 0 ? 20 : _viewBoxWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: height,
        width: width,
        viewBox: "0 0 ".concat(viewBoxWidth, " ").concat(viewBoxHeight),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            transform: "translate(".concat(translateX, " ").concat(translateY, ")"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 0L24 0 24 24 0 24z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: color,
                    fillRule: "nonzero",
                    d: "M2 15L5.63 15 2 19.2 2 21 8 21 8 19 4.37 19 8 14.8 8 13 2 13z"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: color,
                    fillRule: "nonzero",
                    d: "M9 10L12.63 10 9 14.2 9 16 15 16 15 14 11.37 14 15 9.8 15 8 9 8z"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: color,
                    fillRule: "nonzero",
                    d: "M16 5L19.63 5 16 9.2 16 11 22 11 22 9 18.37 9 22 4.8 22 3 16 3z"
                }),
                " "
            ]
        })
    });
};
/* harmony default export */ var HotelsTonight_SleepIcon = (SleepIcon);

// EXTERNAL MODULE: ./src/machines/currentLocationMachine.ts
var currentLocationMachine = __webpack_require__(71626);
;// CONCATENATED MODULE: ./src/components/HotelsTonight/HotelsTonight.tsx











function HotelsTonight() {
    var ref = (0,router.useRouter)(), _pathname = ref.pathname, pathname = _pathname === void 0 ? "/" : _pathname;
    var category = pathname === "/hotels" ? "HOTEL_HOME" : "PCLN_HOME";
    var ref1 = (0,useGeoPosition/* default */.Z)(), latitude = ref1.latitude, longitude = ref1.longitude;
    var relaxListingsCallBack = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, lat, lon, itemName, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(latitude !== null && longitude !== null)) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,currentLocationMachine/* invokeFetchCurrentCityData */.N)(latitude, longitude)
                        ];
                    case 2:
                        ref = _state.sent(), lat = ref.lat, lon = ref.lon, itemName = ref.itemName;
                        window.location.href = "/relax/geo/".concat(itemName, "/").concat(lat, "/").concat(lon, "/from/").concat(date_helper/* defaultToday */.G4, "/to/").concat(date_helper/* defaultTomorrow */.Zx, "/rooms/1");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        analytics/* default.fireEvent */.Z.fireEvent({
                            event: "Error",
                            category: category,
                            action: "Click",
                            data: error.toString()
                        });
                        window.location.href = "/hotels";
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        analytics/* default.fireEvent */.Z.fireEvent({
                            event: "Error",
                            category: category,
                            action: "Click",
                            data: "Latitude/Longitude data could not be fetched"
                        });
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function relaxListingsCallBack() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleHotelsTonightClick = function(event) {
        event.preventDefault();
        analytics/* default.fireEvent */.Z.fireEvent({
            category: category,
            action: "Click",
            label: "Hotel Tonight"
        });
        relaxListingsCallBack();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
            width: 1,
            variation: "link",
            "data-testid": "HOMEPAGE_MWEB_TONIGHT_ONLY_SEARCH",
            onClick: handleHotelsTonightClick,
            target: "_self",
            size: "large",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                color: "background.lightest",
                boxShadowSize: "sm",
                br: "2px",
                borderRadius: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    px: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            pr: 2,
                            mt: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelsTonight_SleepIcon, {
                                color: "#004499",
                                height: 40,
                                translateX: -2,
                                translateY: -1,
                                viewBoxHeight: 20,
                                viewBoxWidth: 20,
                                width: 36
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            p: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    fontWeight: "bold",
                                    color: "black",
                                    fontSize: 2,
                                    textAlign: "left",
                                    children: "Need a hotel tonight?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    color: "text",
                                    mt: 2,
                                    fontSize: 0,
                                    textAlign: "left",
                                    children: "Find deals near you."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "70px",
                            ml: "auto",
                            my: "auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                size: "small",
                                width: 1,
                                children: "Search"
                            })
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 8750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pcln_mobile_header__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77557);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92591);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68464);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66487);









var ANALYTICS_CATEGORY = {
    flights: _constants_analytics__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_CATEGORY_FLIGHTS */ .y1,
    packages: _constants_analytics__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_CATEGORY_PACKAGES */ .Bd
};
var MobileHeaderWrapper = function(_param) {
    var selectedProductName = _param.selectedProductName, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "selectedProductName",
        "children"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), _key = ref.key, key = _key === void 0 ? "" : _key;
    var category = ANALYTICS_CATEGORY[key];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        mt: 2,
        boxShadowSize: "xl",
        rounded: "round",
        borderRadius: "2xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mb: "10px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pcln_mobile_header__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    analyticsCategory: category,
                    items: _pcln_mobile_header__WEBPACK_IMPORTED_MODULE_8__/* ["default"].itemsRefresh */ .Z.itemsRefresh,
                    mustRefreshIcons: true,
                    selectedItem: selectedProductName
                })
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (MobileHeaderWrapper);


/***/ }),

/***/ 29657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);


var useGeoPosition = function() {
    var locale = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(locale.longitude ? locale.longitude : null), longitude = ref[0], setLongitude = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(locale.latitude ? locale.latitude : null), latitude = ref1[0], setLatitude = ref1[1];
    var onSuccess = function(param) {
        var coords = param.coords;
        setLongitude(coords.longitude);
        setLatitude(coords.latitude);
    };
    var onError = function() {
    // TODO: fail silently or log error
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var geo = navigator.geolocation;
        if (!geo) {
            // TODO: potentially log error
            return;
        }
        geo.getCurrentPosition(onSuccess, onError);
    }, []);
    return {
        longitude: longitude,
        latitude: latitude
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGeoPosition);


/***/ })

}]);